module.exports = "/wp-content/themes/onnit/script/cart/dist/nmiOverride-fd00182f.png";